import React, { useState, useEffect } from 'react'
import './style.css'
import { commonService } from '../../../storeManager/common/services'
import GlobalConfig from '../../../globalConfig/globalConfig'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
// import {get} from "lodash";
import { addDays, subDays, compareDesc } from "date-fns";
import Calender from '../../../assets/images/calendar.png'
import { setSession } from '../../../services/commonUtils';
import { useHistory } from 'react-router-dom'
import { closeModal } from '../../../storeManager/modal/actions';
import { useDispatch } from 'react-redux';
import Loader from '../../Loader';
import { getDateFormatYYYYMMDD } from "../../../helper";

function BulkSuspendModal(props) {
    const [newDate] = useState(new Date())
    const [nextDate] = useState(addDays(new Date(), 1))
    const [newDateError, setNewDateError] = useState(null)
    const [nextDateError, setNextDateError] = useState(null)
    const [startKey, setStartKey] = useState()
    const [endKey, setEndKey] = useState()
    // const [payloadData, setPayloadData] = useState()
    const [isLoader, setIsLoader] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const { modalParameters: { operation, boxlistData, selectedStbId, selectedSubId } } = props;

    useEffect(() => {
        //   const sessiondata = sessionStorage.getItem("bulksubid")
        //   const filterdata = boxlistData.filter((user) => sessiondata.includes(user.subscriberId));
        //   setPayloadData(filterdata)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // const { data, getSuspendResumeDetail, radioButtonChangeHandler, checked } = this.props;
    const startKeyName = "startKey";
    const endKeyName = "endKey";
    // const vcStatus = get(data, "vcStatus") === "Active" ? "Suspend" : "Resume";
    const minDate = operation === "Suspend" ? nextDate : newDate;
    const startDate = startKey || (operation === "Suspend" ? nextDate : newDate);
    const toDate = endKey || (operation === "Suspend" ? addDays(startDate, 4) : newDate);
    const minResumeDate = operation === "Suspend" ? addDays(startDate, 4) : startDate;
    const compareToDate = operation === "Suspend" ? subDays(toDate, 4) : toDate;
    const endDate = compareDesc(startDate, compareToDate) === 1 ? toDate : minResumeDate;



    const bulkSuspend = async () => {
        setIsLoader(true)

        if ((newDate && nextDate) || (operation === "Resume" && nextDate)) {

            const payload = {
                "subIdStb": selectedSubId.map(item => item),
                "resDate": getDateFormatYYYYMMDD(endDate),
                "susDate": operation === "Suspend" ? getDateFormatYYYYMMDD(startDate) : '', //"2023-02-28",
                "stbType": boxlistData.find(f => f.stbNumber === selectedStbId[0]).connectionType,
                "actionType": operation,
                "activityType": `Bulk ${operation}`
            };

            try {
                const response = await commonService.bulkSuspend(payload);
                const responseData = response.data;
                setSession('bulkOpetaionResponse', responseData)
                if (responseData.status === GlobalConfig.MESSAGES_TYPES.TRUE) {
                    // const data = responseData.data;
                    setIsLoader(false)
                }else{
                    setIsLoader(false)
                }
                history.push('/operation-success')
            } catch {
                //   console.error(MESSAGES.DID_MOUNT_ERROR);
                setIsLoader(false)
            }
        } else if (!newDate && nextDate) {
            setNewDateError("Please select date")
        }
        else if (newDate && !nextDate) {
            setNextDateError('Please select date')
        }
        else {
            setNewDateError("Please select date")
            setNextDateError('Please select date')
        }

    }

    const handleDateChange = (date, name) => {
        if (name === 'startKey') {
            setStartKey(date)
            setNewDateError(null)
        } else if (name === 'endKey') {
            setEndKey(date)
            setNextDateError(null)
        }
    };
    if (isLoader)
        return (<Loader />)
    return (
        <div id='Bulk-suspend-modal'>
            <div className='gradient-text mb20'>{operation === "Resume" ? 'Please select the date from when you want to resume service' : 'Please select the date till when you want to temporarily suspend?'}</div>
            <div className='formdiv'>
                <div className='lablediv'>
                    <label> From </label>
                    <div className="forminput">
                        <DatePicker
                            className='datePicker'
                            dateFormat="dd/MM/yyyy"
                            selected={startDate}
                            onChange={(date) => { handleDateChange(date, startKeyName) }}
                            //    onSelect={this.handleSelect}
                            minDate={minDate}
                            //    disabled={(checked !== keyName)}
                            showDisabledMonthNavigation
                        /><img src={Calender} alt="" width="17" height='17' />
                    </div>
                    <span className='error-msg'>{newDateError}</span>
                </div>
                <div className='lablediv'>
                    <label> To </label>
                    <div className="forminput">
                        <DatePicker className='datePicker'
                            dateFormat="dd/MM/yyyy"
                            selected={endDate}
                            onChange={(date) => { handleDateChange(date, endKeyName) }}
                            //  onSelect={this.handleSelect}
                            minDate={minResumeDate}
                            //  disabled={(checked !== keyName)}
                            showDisabledMonthNavigation
                        /><img src={Calender} alt="" width="17" height='17' />
                    </div>
                    <span className='error-msg'>{nextDateError}</span>
                </div>
            </div>
            <div className='btn-sec'>
                <button className='btn sec-btn animated1 fadeIn1 btn medium-strong button btn-secondary' type='submit' onClick={() => dispatch(closeModal())}>Back</button>
                <button className='btn btn-primary' type='submit' onClick={bulkSuspend}>{operation}</button>
            </div>
        </div>
    )
}

export default BulkSuspendModal
